import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { postService } from '../services/api';
// import getOptimalAdRoute from '../utils/AdRouter';
import '../styles/Home.css';
import PopUnderAd from '../components/PopUnderAd';
import NativeBanner from '../components/NativeBanner';
import SearchBar from '../components/SearchBar';
import { useSearchParams } from 'react-router-dom';

const Home = () => {
  // const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams(); // ADD THIS LINE
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // const [currentPage, setCurrentPage] = useState(1);
  const currentPage = parseInt(searchParams.get('page')) || 1;

  const [totalPages, setTotalPages] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);
  const postsPerPage = 9;

  // Helper to handle ad frequency capping
  const handleAdTrigger = () => {
    const AD_COOLDOWN = 60 * 60 * 1000; // 1 hour in milliseconds
    const lastPopTime = localStorage.getItem('site_last_pop_time');
    const now = Date.now();

    // If no ad seen yet, or if last ad was seen more than 1 hour ago
    if (!lastPopTime || (now - parseInt(lastPopTime)) > AD_COOLDOWN) {
      // Trigger pop-up ad
      window.open('https://www.profitableratecpmnetwork.com/p30hpe5v?key=308e8f6fbe3fe7839661a714c9301acf', '_blank');

      // Save the current time as the "Last Pop At" time
      localStorage.setItem('site_last_pop_time', now.toString());
    }
  };

  useEffect(() => {
    fetchPosts(currentPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const fetchPosts = async (page) => {
    try {
      setLoading(true);
      const data = await postService.getPaginatedPosts(page, postsPerPage);
      // console.log(data.posts);
      setPosts(data.posts);
      setTotalPages(data.totalPages);
      setTotalPosts(data.totalPosts);
      setError('');
    } catch (err) {
      setError('Failed to load posts. Please try again later.');
      console.error('Error fetching posts:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const truncateText = (text, maxLength = 200) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const paginate = (pageNumber) => {
    setSearchParams({ page: pageNumber });
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setSearchParams({ page: currentPage + 1 });
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setSearchParams({ page: currentPage - 1 });
    }
  };

  if (loading) {
    return (
      <div className="home-container">
        <div className="loading">Loading posts...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="home-container">
        <div className="error">{error}</div>
      </div>
    );
  }

  const indexOfFirstPost = (currentPage - 1) * postsPerPage + 1;
  const indexOfLastPost = Math.min(currentPage * postsPerPage, totalPosts);

  return (
    <div className="home-container">
      <PopUnderAd />

      <div className="home-header">
        <h1>Latest Posts</h1>
        <p>Discover interesting articles and stories</p>
      </div>
      <div className='search-bar-container'>
        <SearchBar />
      </div>

      {totalPosts === 0 || !posts?.length ? (
        <div className="no-posts">
          <p>No posts available yet. Check back later!</p>
        </div>
      ) : (
        <>
          <div className="posts-grid">
            {posts?.length > 0 && posts?.map((post) => (
              <div
                key={post._id}
                onClick={() => {
                  // window.open('https://your-ad-network-url.com', '_blank');
                  handleAdTrigger();
                  window.location.href = `/link1?go=${post._id}`;

                  // const route = getOptimalAdRoute(post._id);
                  // navigate(route);
                }}
                className="post-card"
                style={{ cursor: 'pointer' }}
              >
                <div className="post-card-content">
                  <h2 className="post-title">{post.title}</h2>
                  <p className="post-excerpt">
                    {truncateText(post.body)}
                  </p>
                  <div className="post-meta">
                    <span className="post-author">
                      ✍️ {post.author?.username || 'Anonymous'}
                    </span>
                    <span className="post-date">
                      📅 {formatDate(post.createdAt)}
                    </span>
                    <span className="post-views">
                      👁️ {post.views} views
                    </span>
                  </div>
                </div>
                <div className="post-card-footer">
                  <span className="read-more">Read More →</span>
                </div>
              </div>
            ))}
          </div>
          <NativeBanner />

          {/* {totalPages > 1 && (
            <div className="pagination-container">
              <div className="pagination-info">
                Showing {indexOfFirstPost} - {indexOfLastPost} of {totalPosts} posts
              </div>

              <div className="pagination-controls">
                <button
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                  className="pagination-btn"
                >
                  ← Previous
                </button>

                <div className="pagination-numbers">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                    <button
                      key={number}
                      onClick={() => paginate(number)}
                      className={`pagination-number ${currentPage === number ? 'active' : ''}`}
                    >
                      {number}
                    </button>
                  ))}
                </div>

                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className="pagination-btn"
                >
                  Next →
                </button>
              </div>
            </div>
          )} */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <div className="pagination-info">
                Showing {indexOfFirstPost} - {indexOfLastPost} of {totalPosts} posts
              </div>

              <div className="pagination-controls">
                <button
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                  className="pagination-btn"
                >
                  ← Previous
                </button>

                <div className="pagination-numbers">
                  {/* First page */}
                  {currentPage > 3 && (
                    <>
                      <button
                        onClick={() => paginate(1)}
                        className="pagination-number"
                      >
                        1
                      </button>
                      {currentPage > 4 && <span className="pagination-dots">...</span>}
                    </>
                  )}

                  {/* Pages around current */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(page => {
                      // Show current page and 2 pages on each side
                      return page >= currentPage - 2 && page <= currentPage + 2;
                    })
                    .map(number => (
                      <button
                        key={number}
                        onClick={() => paginate(number)}
                        className={`pagination-number ${currentPage === number ? 'active' : ''}`}
                      >
                        {number}
                      </button>
                    ))}

                  {/* Last page */}
                  {currentPage < totalPages - 2 && (
                    <>
                      {currentPage < totalPages - 3 && <span className="pagination-dots">...</span>}
                      <button
                        onClick={() => paginate(totalPages)}
                        className="pagination-number"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}
                </div>

                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className="pagination-btn"
                >
                  Next →
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Home;